import { SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC } from 'containers/CustomizedAutoSync/constants'
import { AS_GD_ASYNC, AS_O365_ASYNC } from 'containers/Mailboxes/constants'
import {
  QUICK_INTEGRATION_CONTINUE,
  QUICK_INTEGRATION_SAVE_ASYNC,
} from 'containers/Settings/EmailServer/QuickIntegration/constants'

import { FETCH_DEMO_MODE_BANNER_ASYNC } from './constants'

const initialState = {
  showDemoBanner: false,
  mailboxesSyncing: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEMO_MODE_BANNER_ASYNC.SUCCESS:
      return {
        ...state,
        error: null,
        showDemoBanner: action.payload.data.showDemoBanner,
      }
    case FETCH_DEMO_MODE_BANNER_ASYNC.ERROR:
      return { ...state, error: action.error }
    case AS_O365_ASYNC.SUCCESS:
    case AS_GD_ASYNC.SUCCESS:
    case AS_O365_ASYNC.INITIATE:
    case SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.SUCCESS:
    case QUICK_INTEGRATION_SAVE_ASYNC.SUCCESS:
    case QUICK_INTEGRATION_CONTINUE:
      return { ...state, mailboxesSyncing: true }
    default:
      return state
  }
}
